import { MdCalendarMonth } from "react-icons/md";

const PRESETS = [
  { key: "today", label: "اليوم" },
  { key: "7d", label: "7 أيام" },
  { key: "30d", label: "30 يوم" },
  { key: "90d", label: "90 يوم" },
  { key: "thisMonth", label: "هذا الشهر" },
  { key: "lastMonth", label: "الشهر الماضي" },
];

function formatLabel(date) {
  return date.toISOString().slice(0, 10);
}

const DateRangePicker = ({ from, to, onPreset, onChange }) => {
  return (
    <div className="flex flex-wrap items-center gap-2 rounded-xl border border-border-muted bg-white p-2 dark:border-navy-700 dark:bg-navy-800">
      <div className="flex items-center gap-1 text-xs text-gray-500 px-1">
        <MdCalendarMonth className="h-4 w-4" />
        <span>{formatLabel(from)}</span>
        <span className="text-gray-400">→</span>
        <span>{formatLabel(to)}</span>
      </div>
      <div className="flex flex-wrap items-center gap-1">
        {PRESETS.map((p) => (
          <button
            key={p.key}
            type="button"
            onClick={() => onPreset(p.key)}
            className="rounded-md px-2 py-1 text-xs font-medium text-gray-600 hover:bg-info-50 hover:text-info-700"
          >
            {p.label}
          </button>
        ))}
      </div>
      {onChange ? (
        <div className="flex items-center gap-1">
          <input
            type="date"
            value={formatLabel(from)}
            onChange={(e) =>
              onChange({ from: new Date(e.target.value), to })
            }
            className="rounded-md border border-border bg-surface-muted px-2 py-1 text-xs"
          />
          <span className="text-gray-400">→</span>
          <input
            type="date"
            value={formatLabel(to)}
            onChange={(e) =>
              onChange({ from, to: new Date(e.target.value) })
            }
            className="rounded-md border border-border bg-surface-muted px-2 py-1 text-xs"
          />
        </div>
      ) : null}
    </div>
  );
};

export default DateRangePicker;
